export default "__VITE_ASSET__cUluM8e$__"